import commonService from "./common.service";

const p2pLinkedRfqService = {
  listForTransaction: (transactionId) =>
    commonService.get(`/p2p/transactions/${transactionId}/linked-rfqs`),

  link: (transactionId, payload) =>
    commonService.post(`/p2p/transactions/${transactionId}/linked-rfqs`, payload),

  listInvitedVendorIds: (transactionId, linkId) =>
    commonService.get(
      `/p2p/transactions/${transactionId}/linked-rfqs/${linkId}/invited`,
    ),

  inviteVendors: (transactionId, linkId, payload) =>
    commonService.post(
      `/p2p/transactions/${transactionId}/linked-rfqs/${linkId}/invite`,
      payload,
    ),

  broadcastToMatchedSellers: (transactionId, linkId, payload = {}) =>
    commonService.post(
      `/p2p/transactions/${transactionId}/linked-rfqs/${linkId}/broadcast-marketplace`,
      payload,
    ),

  broadcastToMatchedLogisticsProviders: (transactionId, linkId) =>
    commonService.post(
      `/p2p/transactions/${transactionId}/linked-rfqs/${linkId}/broadcast-logistics-providers`,
      {},
    ),

  broadcastToMatchedContractManufacturers: (transactionId, linkId) =>
    commonService.post(
      `/p2p/transactions/${transactionId}/linked-rfqs/${linkId}/broadcast-contract-manufacturers`,
      {},
    ),

  beginQuoteSelection: (transactionId, linkId) =>
    commonService.post(
      `/p2p/transactions/${transactionId}/linked-rfqs/${linkId}/begin-quote-selection`,
      {},
    ),
};

export default p2pLinkedRfqService;
